module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "invoices"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "container"
  }, [_c('table', {
    staticClass: "table table-responsive"
  }, [_vm._m(1), _vm._v(" "), _vm._l((_vm.years), function(year) {
    return _c('tbody', [_c('tr', {
      staticClass: "table-secondary text-center"
    }, [_c('th', {
      attrs: {
        "scope": "row",
        "colspan": "7"
      }
    }, [_c('h3', [_vm._v(_vm._s(year))])])]), _vm._v(" "), _vm._l((_vm.groupedInvoices[year]), function(invoice) {
      return _c('tr', [_c('th', {
        attrs: {
          "scope": "row"
        }
      }, [_vm._v(_vm._s(invoice.number))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(invoice.client.name))]), _vm._v(" "), _c('td', [_vm._v(_vm._s((invoice.type === 'invoice') ? 'Račun' : ((invoice.type === 'proinvoice') ? 'Predračun' : '?')))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm._f("date")(invoice.issueDate)))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm._f("money")(invoice.total)))]), _vm._v(" "), _c('td', [(!invoice.referenceInvoice) ? [(!_vm.isInvoicePaid(invoice)) ? _c('p', {
        staticClass: "mb-1"
      }, [_c('span', {
        staticClass: "badge",
        class: [_vm.isDeadlinePassed(invoice.paymentDeadline.toDate()) ? 'badge-danger' : 'badge-light']
      }, [_vm._v("Rok: " + _vm._s(_vm._f("fromNow")(invoice.paymentDeadline.toDate())))])]) : _vm._e(), _vm._v(" "), _c('table', {
        staticClass: "table table-sm small",
        staticStyle: {
          "width": "auto",
          "margin-bottom": "0"
        }
      }, [_c('tbody', _vm._l((invoice.payments), function(payment, index) {
        return _c('tr', [_c('td', [_vm._v(_vm._s(_vm._f("date")(payment.date)))]), _vm._v(" "), _c('td', {
          staticClass: "text-right"
        }, [_vm._v(_vm._s(_vm._f("money")(payment.amount)))]), _vm._v(" "), _c('td', {
          staticClass: "shrink-column"
        }, [_c('button', {
          staticClass: "btn btn-light btn-xs",
          attrs: {
            "type": "button"
          },
          on: {
            "click": function($event) {
              return _vm.removePayment(invoice.id, index)
            }
          }
        }, [_c('i', {
          staticClass: "material-icons"
        }, [_vm._v("close")])])])])
      }), 0)]), _vm._v(" "), (!_vm.isInvoicePaid(invoice)) ? _c('button', {
        staticClass: "btn btn-light btn-sm",
        attrs: {
          "type": "button",
          "data-toggle": "modal",
          "data-target": "#payment-modal"
        },
        on: {
          "click": function($event) {
            return _vm.showAddPayment(invoice.id)
          }
        }
      }, [_vm._v("Dodaj uplatu")]) : _vm._e(), _vm._v(" "), (invoice.type === 'proinvoice') ? _c('button', {
        staticClass: "btn btn-light btn-sm",
        attrs: {
          "type": "button",
          "data-toggle": "modal",
          "data-target": "#pro2invoice-modal"
        },
        on: {
          "click": function($event) {
            return _vm.showConvertProToInvoice(invoice.id)
          }
        }
      }, [_c('i', {
        staticClass: "material-icons md-18"
      }, [_vm._v("assignment")]), _vm._v(" Napravi račun")]) : _vm._e()] : _vm._e()], 2), _vm._v(" "), _c('td', {
        staticClass: "shrink-column"
      }, [_c('router-link', {
        staticClass: "btn btn-light btn-sm",
        attrs: {
          "to": {
            path: '/invoices/' + invoice.id
          },
          "exact": ""
        }
      }, [_c('i', {
        staticClass: "material-icons md-18"
      }, [_vm._v("open_in_new")])]), _vm._v(" "), _c('button', {
        staticClass: "btn btn-light btn-sm",
        attrs: {
          "type": "button"
        },
        on: {
          "click": function($event) {
            return _vm.removeInvoice(invoice.id)
          }
        }
      }, [_c('i', {
        staticClass: "material-icons md-18"
      }, [_vm._v("delete")])])], 1)])
    })], 2)
  })], 2)]), _vm._v(" "), _c('div', {
    ref: "paymentModal",
    staticClass: "modal fade",
    attrs: {
      "id": "payment-modal",
      "tabindex": "-1",
      "role": "dialog"
    }
  }, [_c('div', {
    staticClass: "modal-dialog modal-sm",
    attrs: {
      "role": "document"
    }
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_vm._m(2), _vm._v(" "), _c('div', {
    staticClass: "modal-body"
  }, [_c('form', [_c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Datum")]), _vm._v(" "), _c('flat-pickr', {
    staticClass: "form-control form-control-sm",
    model: {
      value: (_vm.currentPayment.date),
      callback: function($$v) {
        _vm.$set(_vm.currentPayment, "date", $$v)
      },
      expression: "currentPayment.date"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Iznos")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.currentPayment.amount),
      expression: "currentPayment.amount"
    }],
    staticClass: "form-control form-control-sm",
    attrs: {
      "type": "number",
      "step": "0.01"
    },
    domProps: {
      "value": (_vm.currentPayment.amount)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.currentPayment, "amount", $event.target.value)
      }
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "modal-footer"
  }, [_c('button', {
    staticClass: "btn btn-secondary",
    attrs: {
      "type": "button",
      "data-dismiss": "modal"
    }
  }, [_vm._v("Odustani")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-primary",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.savePayment
    }
  }, [_vm._v("Sačuvaj")])])])])]), _vm._v(" "), _c('div', {
    ref: "pro2InvoiceModal",
    staticClass: "modal fade",
    attrs: {
      "id": "pro2invoice-modal",
      "tabindex": "-1",
      "role": "dialog"
    }
  }, [_c('div', {
    staticClass: "modal-dialog modal-sm",
    attrs: {
      "role": "document"
    }
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_c('div', {
    staticClass: "modal-header"
  }, [_c('h5', {
    staticClass: "modal-title"
  }, [_vm._v("Faktura " + _vm._s(_vm.nextInvoiceNumber))]), _vm._v(" "), _vm._m(3)]), _vm._v(" "), _c('div', {
    staticClass: "modal-body"
  }, [_c('form', [_c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Datum izdavanja")]), _vm._v(" "), _c('flat-pickr', {
    staticClass: "form-control form-control-sm",
    model: {
      value: (_vm.currentInvoice.issueDate),
      callback: function($$v) {
        _vm.$set(_vm.currentInvoice, "issueDate", $$v)
      },
      expression: "currentInvoice.issueDate"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Datum prometa")]), _vm._v(" "), _c('flat-pickr', {
    staticClass: "form-control form-control-sm",
    model: {
      value: (_vm.currentInvoice.deliveryDate),
      callback: function($$v) {
        _vm.$set(_vm.currentInvoice, "deliveryDate", $$v)
      },
      expression: "currentInvoice.deliveryDate"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Rok za plaćanje")]), _vm._v(" "), _c('div', {
    staticClass: "input-group"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.currentInvoice.paymentDeadline),
      expression: "currentInvoice.paymentDeadline"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "number",
      "min": "1"
    },
    domProps: {
      "value": (_vm.currentInvoice.paymentDeadline)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.currentInvoice, "paymentDeadline", $event.target.value)
      }
    }
  }), _vm._v(" "), _vm._m(4)])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Napomena")]), _vm._v(" "), _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.currentInvoice.note),
      expression: "currentInvoice.note"
    }],
    staticClass: "form-control",
    attrs: {
      "rows": "2"
    },
    domProps: {
      "value": (_vm.currentInvoice.note)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.currentInvoice, "note", $event.target.value)
      }
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "modal-footer"
  }, [_c('button', {
    staticClass: "btn btn-secondary",
    attrs: {
      "type": "button",
      "data-dismiss": "modal"
    }
  }, [_vm._v("Odustani")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-primary",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.convertProToInvoice
    }
  }, [_vm._v("Napravi račun")])])])])]), _vm._v(" "), _c('div', {
    ref: "invoiceModal",
    staticClass: "modal fade",
    attrs: {
      "id": "invoice-modal",
      "tabindex": "-1",
      "role": "dialog"
    }
  }, [_c('div', {
    staticClass: "modal-dialog modal-lg",
    attrs: {
      "role": "document"
    }
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_c('div', {
    staticClass: "modal-header"
  }, [_c('h5', {
    staticClass: "modal-title"
  }, [_vm._v("Faktura " + _vm._s(_vm.nextInvoiceNumber))]), _vm._v(" "), _vm._m(5)]), _vm._v(" "), _c('div', {
    staticClass: "modal-body"
  }, [_c('form', [_c('div', {
    staticClass: "form-check form-check-inline"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.currentInvoice.type),
      expression: "currentInvoice.type"
    }],
    staticClass: "form-check-input",
    attrs: {
      "type": "radio",
      "name": "type",
      "value": "invoice"
    },
    domProps: {
      "checked": _vm._q(_vm.currentInvoice.type, "invoice")
    },
    on: {
      "change": function($event) {
        return _vm.$set(_vm.currentInvoice, "type", "invoice")
      }
    }
  }), _vm._v(" "), _c('label', {
    staticClass: "form-check-label"
  }, [_vm._v("Račun")])]), _vm._v(" "), _c('div', {
    staticClass: "form-check form-check-inline"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.currentInvoice.type),
      expression: "currentInvoice.type"
    }],
    staticClass: "form-check-input",
    attrs: {
      "type": "radio",
      "name": "type",
      "value": "proinvoice"
    },
    domProps: {
      "checked": _vm._q(_vm.currentInvoice.type, "proinvoice")
    },
    on: {
      "change": function($event) {
        return _vm.$set(_vm.currentInvoice, "type", "proinvoice")
      }
    }
  }), _vm._v(" "), _c('label', {
    staticClass: "form-check-label"
  }, [_vm._v("Predračun")])]), _vm._v(" "), _c('div', {
    staticClass: "form-row"
  }, [_c('div', {
    staticClass: "form-group col-md-6"
  }, [_c('label', [_vm._v("Klijent")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.currentInvoice.client),
      expression: "currentInvoice.client"
    }],
    staticClass: "form-control",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.currentInvoice, "client", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, _vm._l((_vm.clientState.clients), function(client) {
    return _c('option', {
      domProps: {
        "value": client
      }
    }, [_vm._v(_vm._s(client.name))])
  }), 0)])]), _vm._v(" "), _c('div', {
    staticClass: "form-row"
  }, [_c('div', {
    staticClass: "form-group col-md-4"
  }, [_c('label', [_vm._v("Datum izdavanja")]), _vm._v(" "), _c('flat-pickr', {
    staticClass: "form-control",
    model: {
      value: (_vm.currentInvoice.issueDate),
      callback: function($$v) {
        _vm.$set(_vm.currentInvoice, "issueDate", $$v)
      },
      expression: "currentInvoice.issueDate"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "form-group col-md-4"
  }, [_c('label', [_vm._v("Mesto izdavanja")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.currentInvoice.issuePlace),
      expression: "currentInvoice.issuePlace"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.currentInvoice.issuePlace)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.currentInvoice, "issuePlace", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-row"
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.currentInvoice.type === 'invoice'),
      expression: "currentInvoice.type === 'invoice'"
    }],
    staticClass: "form-group col-md-4"
  }, [_c('label', [_vm._v("Datum prometa")]), _vm._v(" "), _c('flat-pickr', {
    staticClass: "form-control",
    model: {
      value: (_vm.currentInvoice.deliveryDate),
      callback: function($$v) {
        _vm.$set(_vm.currentInvoice, "deliveryDate", $$v)
      },
      expression: "currentInvoice.deliveryDate"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "form-group col-md-4"
  }, [_c('label', [_vm._v("Rok za plaćanje")]), _vm._v(" "), _c('div', {
    staticClass: "input-group"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.currentInvoice.paymentDeadline),
      expression: "currentInvoice.paymentDeadline"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "number",
      "min": "1"
    },
    domProps: {
      "value": (_vm.currentInvoice.paymentDeadline)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.currentInvoice, "paymentDeadline", $event.target.value)
      }
    }
  }), _vm._v(" "), _vm._m(6)])])]), _vm._v(" "), _c('div', {
    staticClass: "form-row"
  }, [_c('div', {
    staticClass: "form-group col-md-8"
  }, [_c('label', [_vm._v("Napomena")]), _vm._v(" "), _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.currentInvoice.note),
      expression: "currentInvoice.note"
    }],
    staticClass: "form-control",
    attrs: {
      "rows": "2"
    },
    domProps: {
      "value": (_vm.currentInvoice.note)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.currentInvoice, "note", $event.target.value)
      }
    }
  })])])]), _vm._v(" "), _c('table', {
    staticClass: "table table-hover table-responsive table-sm mt-4"
  }, [_vm._m(7), _vm._v(" "), _c('tbody', _vm._l((_vm.currentInvoice.items), function(item, index) {
    return _c('tr', [_c('th', {
      attrs: {
        "scope": "row"
      }
    }, [_vm._v(_vm._s(index + 1))]), _vm._v(" "), _c('td', {
      staticClass: "w-50"
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (item.name),
        expression: "item.name"
      }],
      staticClass: "form-control form-control-sm form-control-plaintext",
      attrs: {
        "type": "text"
      },
      domProps: {
        "value": (item.name)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(item, "name", $event.target.value)
        }
      }
    })]), _vm._v(" "), _c('td', [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (item.quantity),
        expression: "item.quantity"
      }],
      staticClass: "form-control form-control-sm form-control-plaintext",
      attrs: {
        "type": "number",
        "min": "1",
        "step": "1"
      },
      domProps: {
        "value": (item.quantity)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(item, "quantity", $event.target.value)
        }
      }
    })]), _vm._v(" "), _c('td', [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (item.price),
        expression: "item.price"
      }],
      staticClass: "form-control form-control-sm form-control-plaintext",
      attrs: {
        "type": "number",
        "step": "0.01"
      },
      domProps: {
        "value": (item.price)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(item, "price", $event.target.value)
        }
      }
    })]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm._f("money")((item.quantity * item.price))))]), _vm._v(" "), _c('td', {
      staticClass: "shrink-column"
    }, [_c('button', {
      staticClass: "btn btn-light btn-sm",
      attrs: {
        "type": "button"
      },
      on: {
        "click": function($event) {
          return _vm.removeInvoiceItem(index)
        }
      }
    }, [_c('i', {
      staticClass: "material-icons md-18"
    }, [_vm._v("delete")])])])])
  }), 0)]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-dark btn-sm",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.addInvoiceItem
    }
  }, [_c('i', {
    staticClass: "material-icons md-18"
  }, [_vm._v("add")]), _vm._v(" Dodaj stavku")]), _vm._v(" "), _c('h3', {
    staticClass: "text-right mt-4"
  }, [_c('small', {
    staticClass: "text-muted"
  }, [_vm._v("Ukupno")]), _vm._v(" " + _vm._s(_vm._f("money")(_vm.currentInvoiceTotal)))])]), _vm._v(" "), _c('div', {
    staticClass: "modal-footer"
  }, [_c('button', {
    staticClass: "btn btn-secondary",
    attrs: {
      "type": "button",
      "data-dismiss": "modal"
    }
  }, [_vm._v("Odustani")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-primary",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.saveInvoice
    }
  }, [_vm._v("Sačuvaj")])])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "jumbotron"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('h1', {
    staticClass: "display-3"
  }, [_vm._v("Fakture")]), _vm._v(" "), _c('p', [_vm._v("Pregled i kreiranje faktura.")]), _vm._v(" "), _c('p', {
    staticClass: "lead"
  }, [_c('button', {
    staticClass: "btn btn-primary btn-lg",
    attrs: {
      "type": "button",
      "data-toggle": "modal",
      "data-target": "#invoice-modal"
    }
  }, [_vm._v("Kreiraj fakturu")])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', {
    staticClass: "thead-dark"
  }, [_c('tr', [_c('th', [_vm._v("#")]), _vm._v(" "), _c('th', [_vm._v("Klijent")]), _vm._v(" "), _c('th', [_vm._v("Tip")]), _vm._v(" "), _c('th', [_vm._v("Datum izdavanja")]), _vm._v(" "), _c('th', [_vm._v("Ukupno")]), _vm._v(" "), _c('th', [_vm._v("Uplate")]), _vm._v(" "), _c('th', {
    staticClass: "shrink-column"
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "modal-header"
  }, [_c('h5', {
    staticClass: "modal-title"
  }, [_vm._v("Nova uplata")]), _vm._v(" "), _c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "data-dismiss": "modal",
      "aria-label": "Close"
    }
  }, [_c('span', {
    attrs: {
      "aria-hidden": "true"
    }
  }, [_vm._v("×")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "data-dismiss": "modal",
      "aria-label": "Close"
    }
  }, [_c('span', {
    attrs: {
      "aria-hidden": "true"
    }
  }, [_vm._v("×")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "input-group-append"
  }, [_c('div', {
    staticClass: "input-group-text"
  }, [_vm._v("dana")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "data-dismiss": "modal",
      "aria-label": "Close"
    }
  }, [_c('span', {
    attrs: {
      "aria-hidden": "true"
    }
  }, [_vm._v("×")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "input-group-append"
  }, [_c('div', {
    staticClass: "input-group-text"
  }, [_vm._v("dana")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', {
    staticClass: "thead-default"
  }, [_c('tr', [_c('th', [_vm._v("#")]), _vm._v(" "), _c('th', [_vm._v("Naziv usluge")]), _vm._v(" "), _c('th', [_vm._v("Količina")]), _vm._v(" "), _c('th', [_vm._v("Cena")]), _vm._v(" "), _c('th', [_vm._v("Ukupno")]), _vm._v(" "), _c('th', {
    staticClass: "shrink-column"
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-512071ce","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Invoices.vue
// module id = 295
// module chunks = 1